// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__m4bYx","title":"Menu_title__ImAM1"};